module.exports = __webpack_public_path__ + "2cf80cce8a51b64f476c49b10d4bc9a3.jpg";